/**
 * Gesperrte Spuren.
 *
 * Eine Sperre, die nur die Zeitleiste beachtet, ist keine: dieselbe Änderung
 * käme über die Werkzeugleiste, die Tastatur, die Anfasser auf der Leinwand
 * oder ein Blatt trotzdem durch. Deshalb wird hier geprüft — an der einen
 * Stelle, durch die jede Änderung muss.
 *
 * Was verboten ist: alles, was einen Clip auf einer gesperrten Spur anfasst,
 * etwas auf sie legt oder sie selbst entfernt. Was erlaubt bleibt: die Spur
 * einzustellen — sonst käme man nie wieder heraus.
 */
function gesperrteSpuren(timeline) {
    return new Set(timeline.tracks.filter((t) => t.locked).map((t) => t.id));
}
/** Auf welcher Spur liegt dieser Clip? */
function spurVon(timeline, clipId) {
    for (const track of timeline.tracks) {
        if (track.clips.some((c) => c.id === clipId))
            return track.id;
    }
    return null;
}
/** Rührt die Änderung an etwas Gesperrtes? */
export function trifftSperre(timeline, op) {
    const zu = gesperrteSpuren(timeline);
    if (zu.size === 0)
        return false;
    switch (op.op) {
        case 'addClip':
            return zu.has(op.trackId);
        case 'moveClip': {
            const her = spurVon(timeline, op.clipId);
            return zu.has(op.toTrackId) || (her !== null && zu.has(her));
        }
        case 'removeClip':
        case 'updateClip':
        case 'setClipEffects':
        case 'setTransition': {
            const spur = spurVon(timeline, op.clipId);
            return spur !== null && zu.has(spur);
        }
        case 'removeTrack':
            return zu.has(op.trackId);
        // Die Spur selbst einstellen bleibt erlaubt: das Schloss muss sich wieder
        // öffnen lassen. Alles Übrige (Format, Untertitel, Marke) hängt nicht an
        // einer Spur.
        default:
            return false;
    }
}
/**
 * Die Änderungen, die durchgehen — und ob etwas an einer Sperre hängen blieb,
 * damit die App es sagen kann, statt stumm nichts zu tun.
 */
export function ohneGesperrte(timeline, ops) {
    const erlaubt = ops.filter((op) => !trifftSperre(timeline, op));
    return { erlaubt, gesperrt: ops.length - erlaubt.length };
}
//# sourceMappingURL=sperre.js.map